import { useInfiniteQuery } from '@tanstack/react-query';
import {
  DetailsLoading,
  IFlowNavigationTab,
  PERFORMANCE_DEFAULT_LIMIT,
  performanceEntityQuery,
  performanceGraphqlFlattenWorks,
  useEntityPageStore,
  usePerformanceGraphQLParameters,
} from '@diana/core';
import { getThingsGraphQLWorksQueryKey } from '../../../../../ThingsPage/Support';
import { NavigationRenderer } from '../../../../../../components/NavigationTabs/NavigationRenderer';

export function ThingNavigation({ flowId, peoplePage }: { flowId?: string; peoplePage: boolean }) {
  const flow = useEntityPageStore((store) => store.flow);
  const queryParameters = usePerformanceGraphQLParameters({
    flows: flow ? [flow] : [],
    filters: [],
    filtersValues: {},
  });

  const queryKeys = getThingsGraphQLWorksQueryKey(flowId!, queryParameters.filterProperties);
  const { data, isFetching, fetchNextPage, isFetchingNextPage } = useInfiniteQuery({
    queryKey: queryKeys,
    queryFn: async ({ pageParam }) => {
      const data = await performanceEntityQuery
        .get({ ...queryParameters, peoplePage })
        .fn({ skip: pageParam as number });

      if (data.length === PERFORMANCE_DEFAULT_LIMIT) {
        setTimeout(() => fetchNextPage(), 0);
      }

      return data;
    },
    enabled: flow && Object.values(flow).length > 0,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    initialPageParam: 0,
    getNextPageParam: (_, allPages) => performanceGraphqlFlattenWorks(allPages).length,
  });

  const isEntityLoading = isFetching || isFetchingNextPage;
  const unfilteredEntities = performanceGraphqlFlattenWorks(data);
  const entities = unfilteredEntities.filter((work) => work.flowOriginId === flow?.flowOriginId);

  if (isEntityLoading) {
    return <DetailsLoading />;
  }

  const config = (flow?.flowFeatures?.leftPanel?.tabs?.find((t) => t.tab === 'navigation') ??
    {}) as IFlowNavigationTab;

  return <NavigationRenderer works={entities} {...config} isEntities peoplePage={peoplePage} />;
}
